var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-container"},_vm._l((_vm.videoTilesOrganized),function(videoTile,index){return _c('VideoTile',{key:index,attrs:{"video-tile":videoTile},on:{"loaded":function($event){_vm.loadedCount+=1}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }